import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import SidebarTooltip from "./elements/SidebarTooltip";
import SmartIcon from "../../components/generic/genericIcon/SmartIcon";

const HelpDesk = ({ mobileOpen, open }) => {
  return (
    <ListItem disablePadding>
      <SidebarTooltip title="Help Desk" placement="right" arrow>
        <ListItemButton
          onClick={() => {
            window.open(
              "https://pdv2.on.spiceworks.com/portal/registrations",
              "_blank"
            );
          }}
          sx={{
            minHeight: 48,
            justifyContent: mobileOpen || open ? "initial" : "center",
            px: 2.5,
            "&.Mui-selected": {
              backgroundColor: "var(--main-theme-color) !important",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "var(--main-theme-color) !important",
            },
          }}
        >
          <ListItemIcon
            edge="start"
            sx={{
              minWidth: 0,
              mr: mobileOpen || open ? 2 : "auto",
              justifyContent: "center",
              ml: 0.4,
            }}
          >
            <SmartIcon
              color={"var(--secondary-theme-color)"}
              iconKey={"helpdesk"}
              width={20}
              height={20}
            />
          </ListItemIcon>
          <ListItemText
            primary={"Help Desk"}
            sx={{
              opacity: mobileOpen || open ? 1 : 0,
              marginBottom: 0,
            }}
          />
        </ListItemButton>
      </SidebarTooltip>
    </ListItem>
  );
};

export default HelpDesk;
